import { createContext, useContext } from 'react';

/** What a header form inside a `HeaderSaveGuard` saves against. */
export interface HeaderSaveVersion {
    /** The `headerVersion` the form was loaded from, or last saved as. */
    baseVersion: { current: string | undefined };
    /** Called with the server's message when a save is refused because someone else saved first. */
    onConflict: (message: string) => void;
}

export const HeaderSaveVersionContext = createContext<HeaderSaveVersion | null>(null);

/** The enclosing guard's version, or null outside one (saves then go unchecked). */
export const useHeaderSaveVersion = () => useContext(HeaderSaveVersionContext);
